<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="10" :md="10">
            <a-button
              type="primary"
              icon="plus"
              size="small"
              @click="AddClick"
              style="margin-right: 10px"
              v-if="isAdmin"
            >
              新增类型
            </a-button>
          </a-col>
        </a-row>
        <a-row type="flex" align="middle">
          <a-col
            :span="24"
            :md="24"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-select
              v-model:value="Query.cateIds"
              mode="multiple"
              show-search
              style="width: 100%; margin-right: 10px"
              placeholder="类型分类"
              :options="options"
              :filter-option="filterOption"
              size="small"
              :max-tag-count="MaxCateSelCount"
            />
            <a-input
              v-model="Query.skey"
              placeholder="模糊关键词类型"
              size="small"
              style="width: 150px; margin-right: 10px"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              @click="SearchClieck()"
            >
              查询
            </a-button>
          </a-col>
        </a-row>
      </template>

      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        size="small"
        :expandRowByClick="true"
      >
        <template slot="expandedRowRender" slot-scope="record">
          <div style="padding: 16px">
            <p style="margin: 0 0 10px 0; font-weight: 600">历史名称：</p>
            <div
              class="tag-container"
              :ref="`tagContainer-${record.id}`"
            >
              <a-tag
                v-for="(item, index) in record.lastNameList"
                :key="index"
                color="#108ee9"
              >
                {{ item }}
              </a-tag>
            </div>
          </div>
        </template>
        <template slot="cateList" slot-scope="row" style="max-width: 200px">
          <a-tag
            v-for="(item, index) in row.cateList"
            :key="index"
            color="#2db7f5"
            style="margin-right: 5px"
            >{{ item.cateName }}</a-tag
          >
        </template>

        <template slot="dmList" slot-scope="row" style="max-width: 200px">
          <a-tag
            v-for="(item, index) in row.dmList"
            :key="index"
            color="#2db7f5"
            style="margin-right: 5px"
            >{{ item }}</a-tag
          >
        </template>

        <template slot="chart" slot-scope="row">
          <span class="icon" @click.stop="OpenKeytypeChart(row)">
            <svg
              t="1763434425676"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4712"
              width="32"
              height="32"
            >
              <path
                d="M85.504 938.688H1024V1024H0v-85.312h0.192V0h85.312v938.688zM128 723.328l212.736-271.552 303.424 155.52L990.912 256v632.64H128v-165.312z"
                fill="#ffffff"
                p-id="4713"
              ></path>
            </svg>
          </span>
        </template>
        <template slot="editBtn" slot-scope="row">
          <a-button
            type="primary"
            icon="edit"
            shape="round"
            :data-id="row.id"
            size="small"
            style="margin-right: 10px"
            @click="UserEditClick(row)"
            >编辑</a-button
          >
          <a-button
            type="danger"
            icon="delete"
            shape="round"
            :data-id="row.id"
            size="small"
            @click="UserDelClick(row)"
            >删除</a-button
          >
        </template>
      </a-table>

      <div class="PageCom">
        <el-pagination
          background
          :current-page="Page.index"
          :page-sizes="Page.sizes"
          :page-size="Page.size"
          :total="Page.total"
          layout="sizes, total, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
import { getKeytypeList, keytypeDel } from "@/api/keytype";
import store from "@/store";
export default {
  props: {
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      Query: {
        skey: "",
        cateIds: [],
      },
      columns: [
        {
          title: "类型名称",
          dataIndex: "keyType",
          key: "keyType",
        },
        {
          title: "添加人",
          dataIndex: "userName",
          key: "userName",
        },
        {
          title: "类型",
          key: "cateList",
          scopedSlots: { customRender: "cateList" },
        },
        {
          title: "代码",
          key: "dmList",
          scopedSlots: { customRender: "dmList" },
        },
        { title: "更新时间", dataIndex: "createTime", key: "createTime" },
        {
          title: "数据",
          key: "chart",
          scopedSlots: { customRender: "chart" },
        },
      ],
      tableData: [],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      MaxCateSelCount: 4,
      isAdmin: store.getters.roles.includes("admin"),
    };
  },
  created() {
    this.GetTableData();
    if(this.isAdmin){
      this.columns.push({
        title: "操作",
        key: "editBtn",
        scopedSlots: { customRender: "editBtn" },
      });
    }
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetTableData(this.Query);
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.GetTableData(this.Query);
    },
    TableRowClick(record, index) {
      return {
        on: {
          dblclick: () => {
            console.log(record, index); // 输出当前行的信息和索引
          },
        },
      };
    },

    GetTableData() {
      getKeytypeList(
        this.Query.skey,
        this.Query.cateIds,
        this.Page.index,
        this.Page.size
      )
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.Page.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    SearchClieck() {
      this.Page.index = 1;
      this.GetTableData();
    },
    AddClick() {
      this.$emit("addClick");
    },
    UserEditClick(row) {
      this.$emit("editClick", row);
    },
    UserDelClick(row) {
      this.$confirm("此操作将永久删除此类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          keytypeDel(row.id).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.GetTableData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    OpenKeytypeChart(row) {
      try {
        // 直接构建完整URL，不依赖Vue Router的resolve方法
        const baseUrl = window.location.origin + window.location.pathname;
        const queryString = `?id=${row.id}`;
        const fullUrl = baseUrl + "#/keytype-chart" + queryString;

        console.log("直接构建的完整URL:", fullUrl);

        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        this.$router.push({
          path: "/keytype-chart",
          query: { id: row.id },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  background-color: #1296db;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin: 7px;
  vertical-align: middle;
  cursor: pointer;
}
</style>